"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.axisYStyle = exports.baseLabelStyles = exports.sansSerif = void 0;

var _lodash = require("lodash");

var _colors = _interopRequireDefault(require("./colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Color scale
var colorScale = [_colors.default.palette.yellow2, _colors.default.palette.lime3, _colors.default.palette.fuchsia4, _colors.default.palette.blue5, _colors.default.palette.grey6, _colors.default.palette.grey7, _colors.default.palette.green8];
var primaryColor = _colors.default.palette.base; // Typography

var sansSerif = '"Fira Sans", sans-serif';
exports.sansSerif = sansSerif;
var letterSpacing = 'normal';
var fontSize = 10; // Layout

var baseProps = {
  width: 450,
  height: 300,
  colorScale: colorScale,
  padding: 50,
  domainPadding: 25,
  overflow: 'visible'
}; // Labels

var baseLabelStyles = {
  fontFamily: sansSerif,
  fontSize: fontSize,
  letterSpacing: letterSpacing,
  padding: 10,
  fill: _colors.default.palette.black,
  stroke: 'transparent',
  border: '1px solid black'
};
exports.baseLabelStyles = baseLabelStyles;
var centeredLabelStyles = (0, _lodash.assign)({
  textAnchor: 'middle'
}, baseLabelStyles); // Strokes

var strokeDasharray = '1, 3';
var strokeLinecap = 'round';
var strokeLinejoin = 'round';
var axisYStyle = {
  grid: {
    stroke: _colors.default.palette.black,
    strokeOpacity: '0.5',
    strokeDasharray: strokeDasharray,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin
  },
  axis: {
    fill: 'transparent',
    stroke: 'transparent'
  },
  axisLabel: (0, _lodash.assign)({}, centeredLabelStyles, {
    padding: 25
  }),
  ticks: {
    fill: 'transparent',
    stroke: 'transparent'
  }
};
exports.axisYStyle = axisYStyle;
var victoryTheme = {
  area: (0, _lodash.assign)({
    style: {
      data: {
        fill: primaryColor
      },
      labels: centeredLabelStyles
    }
  }, baseProps),
  axis: (0, _lodash.assign)({}, baseProps, {
    style: {
      axis: {
        fill: 'transparent',
        stroke: _colors.default.palette.black,
        strokeWidth: 1,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin
      },
      axisLabel: (0, _lodash.assign)({}, centeredLabelStyles, {
        padding: 25
      }),
      grid: {
        fill: 'transparent',
        stroke: 'transparent',
        pointerEvents: 'none'
      },
      ticks: {
        fill: 'transparent',
        size: 5,
        stroke: _colors.default.palette.black
      },
      tickLabels: baseLabelStyles
    }
  }),
  bar: (0, _lodash.assign)({
    style: {
      data: {
        fill: primaryColor,
        padding: 8,
        strokeWidth: 0,
        width: 20
      },
      labels: baseLabelStyles
    }
  }, baseProps),
  candlestick: (0, _lodash.assign)({
    style: {
      data: {
        stroke: primaryColor,
        strokeWidth: 1
      },
      labels: centeredLabelStyles
    },
    candleColors: {
      positive: '#ffffff',
      negative: primaryColor
    }
  }, baseProps),
  chart: baseProps,
  errorbar: (0, _lodash.assign)({
    style: {
      data: {
        fill: 'transparent',
        stroke: primaryColor,
        strokeWidth: 2
      },
      labels: centeredLabelStyles
    }
  }, baseProps),
  group: (0, _lodash.assign)({
    colorScale: colorScale
  }, baseProps),
  line: (0, _lodash.assign)({
    style: {
      data: {
        fill: 'transparent',
        stroke: primaryColor,
        strokeWidth: 2
      },
      labels: centeredLabelStyles
    }
  }, baseProps),
  pie: {
    style: {
      data: {
        padding: 10,
        stroke: 'transparent',
        strokeWidth: 1
      },
      labels: (0, _lodash.assign)({
        padding: 20
      }, baseLabelStyles)
    },
    colorScale: colorScale,
    width: 400,
    height: 400,
    padding: 50
  },
  scatter: (0, _lodash.assign)({
    style: {
      data: {
        fill: primaryColor,
        stroke: 'transparent',
        strokeWidth: 0
      },
      labels: centeredLabelStyles
    }
  }, baseProps),
  stack: (0, _lodash.assign)({
    colorScale: colorScale
  }, baseProps),
  tooltip: {
    style: (0, _lodash.assign)({
      padding: 5,
      pointerEvents: 'none'
    }, centeredLabelStyles),
    flyoutStyle: {
      stroke: primaryColor,
      strokeWidth: 1,
      fill: 'red',
      pointerEvents: 'none'
    },
    cornerRadius: 0,
    pointerLength: 0
  },
  voronoi: {
    style: (0, _lodash.assign)({
      data: {
        fill: 'transparent',
        stroke: 'transparent',
        strokeWidth: 0
      },
      labels: (0, _lodash.assign)({
        padding: 5,
        pointerEvents: 'none'
      }, centeredLabelStyles),
      flyout: {
        stroke: primaryColor,
        strokeWidth: 1,
        fill: '#f0f0f0',
        pointerEvents: 'none'
      }
    }, baseProps)
  },
  legend: {
    colorScale: colorScale,
    gutter: 10,
    orientation: 'vertical',
    style: {
      data: {
        type: 'circle'
      },
      labels: baseLabelStyles
    },
    symbolSpacer: 8
  }
};
var _default = victoryTheme;
exports.default = _default;